function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.412 1.908c-.905 1.47.832 5.615 2.949 7.732l.002-.002c2.117 2.116 6.258 3.855 7.73 2.95 1.01-.621.915-3.075.15-3.82-.506-.493-2.055-.748-2.693-.62-.2.04-.76.617-1.07.939l-.15.154c-.23.228-1.69-1.02-2.124-1.453L7.6 9.398l1.605-1.611C8.772 7.354 7.53 5.899 7.76 5.671c.037-.038.09-.09.153-.15.322-.312.9-.87.94-1.07.127-.64-.128-2.188-.62-2.694-.746-.765-3.2-.86-3.821.15z",
  fill: "#fff"
});

var SvgSip = function SvgSip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 14",
    fill: "none"
  }), _ref);
};

export default SvgSip;